<div class="mx-auto max-w-3xl px-4 py-8 sm:px-6 lg:px-8">
  <div class="overflow-hidden rounded-2xl border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 shadow-sm">
    <div class="border-b border-gray-100 dark:border-zinc-800 bg-gradient-to-br from-slate-50 via-white to-blue-50 dark:from-zinc-900 dark:via-zinc-900 dark:to-zinc-800 px-6 py-8 sm:px-8">
      <div class="flex flex-wrap items-start justify-between gap-4">
        <div class="max-w-xl">
          <p class="text-xs font-semibold uppercase tracking-wide text-primary">SHOUT Support</p>
          <h1 class="mt-2 text-2xl font-semibold text-primary sm:text-3xl">How can we help?</h1>
          <p class="mt-2 text-sm leading-6 text-secondary">
            Open a ticket and our team will review your message. You can reply here anytime and we'll notify you when we respond.
          </p>
          @if (avgResponseLabel(); as label) {
            <div class="mt-4 inline-flex flex-col gap-0.5 rounded-2xl border border-green-200 bg-green-50 px-3 py-2 text-green-800 dark:border-green-800 dark:bg-green-900/30 dark:text-green-300">
              <div class="inline-flex items-center gap-2 text-xs font-medium">
                <svg class="size-4 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
                <p class="m-0">Average response time: {{ label }}</p>
              </div>
              <p class="m-0 pl-6 text-xs font-normal text-green-700/80 dark:text-green-300/80">
                for tickets submitted Mon–Fri, 9am–5pm
              </p>
            </div>
          } @else if (statsLoading()) {
            <div class="mt-4 inline-flex items-center gap-2 rounded-full border border-green-200 bg-green-50 px-3 py-1.5 text-xs font-medium text-green-800 dark:border-green-800 dark:bg-green-900/30 dark:text-green-300" aria-busy="true" aria-label="Loading average response time">
              <svg class="size-4 shrink-0 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <p class="m-0">Loading response time…</p>
            </div>
          }
        </div>
        <a routerLink="/support/new" class="btn-basic-sm btn-primary">
          Open a ticket
        </a>
      </div>
    </div>
  </div>

  <div class="mt-8 flex gap-1 rounded-xl border border-gray-200 dark:border-zinc-700 bg-gray-50 dark:bg-zinc-900 p-1">
    <button type="button" (click)="setTab('open')" [class]="tabClass('open')">Open</button>
    <button type="button" (click)="setTab('closed')" [class]="tabClass('closed')">Closed</button>
    <button type="button" (click)="setTab('all')" [class]="tabClass('all')">All</button>
  </div>

  @if (loading()) {
    <div class="mt-6 space-y-3" aria-busy="true" aria-label="Loading tickets">
      @for (item of [1, 2, 3]; track item) {
        <div class="h-20 animate-pulse rounded-xl border border-gray-100 dark:border-zinc-800 bg-gray-50 dark:bg-zinc-800"></div>
      }
    </div>
  } @else if (tickets().length === 0) {
    <div class="mt-6 rounded-2xl border border-dashed border-gray-300 dark:border-zinc-600 bg-gray-50 dark:bg-zinc-900 px-6 py-12 text-center">
      <div class="mx-auto flex size-12 items-center justify-center rounded-full bg-white dark:bg-zinc-800 shadow-sm ring-1 ring-gray-200 dark:ring-zinc-700">
        <svg class="size-6 text-secondary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
        </svg>
      </div>
      <h2 class="mt-4 text-base font-semibold text-primary">{{ emptyStateTitle() }}</h2>
      <p class="mx-auto mt-2 max-w-sm text-sm text-secondary">
        Tell us what's going on and we'll get back to you soon.
      </p>
      <a routerLink="/support/new" class="btn-basic-sm btn-primary mt-5 inline-flex">
        {{ newTicketButtonLabel() }}
      </a>
    </div>
  } @else {
    <ul class="mt-6 space-y-3">
      @for (ticket of tickets(); track ticket.id) {
        <li>
          <button
            type="button"
            (click)="openTicket(ticket.id)"
            class="flex w-full items-start justify-between gap-4 rounded-xl border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 px-4 py-4 text-left shadow-sm transition hover:border-gray-300 dark:hover:border-zinc-600 hover:bg-gray-50 dark:hover:bg-zinc-800">
            <div class="min-w-0">
              <p class="truncate font-medium text-primary">{{ ticket.subject }}</p>
              <p class="mt-1 text-xs text-secondary">{{ formatDateTime(ticket.lastMessageAt) }}</p>
            </div>
            <span class="shrink-0 rounded-full px-2.5 py-0.5 text-xs font-medium" [class]="statusClass(ticket.status)">
              {{ statusLabel(ticket.status) }}
            </span>
          </button>
        </li>
      }
    </ul>
  }
</div>
